import React from 'react';
import UPPage from '../components/UPPage';
import { RouteComponentProps } from 'react-router';

const LoginFormLazy = React.lazy(() =>
  import('./../components/LoginWithInternalUrl')
);

/**
 * Main Page
 */

export default function(
  props: RouteComponentProps<{ internalUrl: string; [key: number]: string }>
) {
  // const [resend, setResend] = useState(0);
  // const { isLogged, response } = useProxyAuth(resend);

  let content;
  content = (
    <LoginFormLazy
      typeLogin="NonPersonalizedLogin"
      internalUrl={props.match.params.internalUrl || props.match.params[0]}
    />
  );

  return <UPPage>{content}</UPPage>;
}
